import { useEffect, useRef } from 'preact/hooks'

import { buildCurrencyPairUrl, currencyPairToSlug, getCurrentSlug } from 'utils/currency-pair-url'

import { DEFAULT_EXCHANGE_DATA } from '../config'
import { getCurrenciesFromSlug } from '../utils/getCurrenciesFromSlug'

interface UseSyncCurrenciesWithSlugProps {
  supportedCurrenciesPairs: string[]
  baseCurrency: string
  counterCurrency: string
  setBaseCurrency: (currency: string) => void
  setCounterCurrency: (currency: string) => void
}

export const useSyncCurrenciesWithSlug = ({
  supportedCurrenciesPairs,
  baseCurrency,
  counterCurrency,
  setBaseCurrency,
  setCounterCurrency,
}: UseSyncCurrenciesWithSlugProps) => {
  const skipRedirectRef = useRef(true)

  useEffect(() => {
    const { baseCurrency: slugBase, counterCurrency: slugCounter } = getCurrenciesFromSlug()
    const isDefaultPair =
      slugBase === DEFAULT_EXCHANGE_DATA.baseCurrency && slugCounter === DEFAULT_EXCHANGE_DATA.counterCurrency

    if (isDefaultPair) {
      skipRedirectRef.current = false
    }

    setBaseCurrency(slugBase)
    setCounterCurrency(slugCounter)
  }, [setBaseCurrency, setCounterCurrency])

  useEffect(() => {
    const baseCurrencyUpper = baseCurrency.toUpperCase()
    const counterCurrencyUpper = counterCurrency.toUpperCase()
    const firstCombination = `${baseCurrencyUpper}${counterCurrencyUpper}`
    const secondCombination = `${counterCurrencyUpper}${baseCurrencyUpper}`

    if (skipRedirectRef.current) {
      skipRedirectRef.current = false
      return
    }

    const found = supportedCurrenciesPairs.find((pair) => pair === firstCombination || pair === secondCombination)

    if (!found) {
      return
    }

    const currentSlug = getCurrentSlug()
    const foundSlug = currencyPairToSlug(found)

    if (foundSlug !== currentSlug) {
      window.location.href = buildCurrencyPairUrl(foundSlug)
    }
  }, [baseCurrency, counterCurrency, supportedCurrenciesPairs])
}
